document.addEventListener('DOMContentLoaded', function () {
  // Slider comparateur d'images
  document.querySelectorAll('[data-compare-slider]').forEach(function (root) {
    var frame = root.querySelector('.compare-slider__frame');
    var after = root.querySelector('[data-compare-after]');
    var divider = root.querySelector('[data-compare-divider]');
    var dragging = false;

    function setPosition(percent) {
      percent = Math.max(0, Math.min(100, percent));
      after.style.clipPath = 'inset(0 0 0 ' + percent + '%)';
      divider.style.left = percent + '%';
    }

    function positionFromEvent(e) {
      var rect = frame.getBoundingClientRect();
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      var percent = ((clientX - rect.left) / rect.width) * 100;
      setPosition(percent);
    }

    frame.addEventListener('mousedown', function (e) { dragging = true; positionFromEvent(e); });
    window.addEventListener('mouseup', function () { dragging = false; });
    window.addEventListener('mousemove', function (e) { if (dragging) positionFromEvent(e); });

    frame.addEventListener('touchstart', function (e) { dragging = true; positionFromEvent(e); }, { passive: true });
    window.addEventListener('touchend', function () { dragging = false; });
    window.addEventListener('touchmove', function (e) { if (dragging) positionFromEvent(e); }, { passive: true });

    // Flèches: nudge de 10%
    var handle = root.querySelector('[data-compare-handle]');
    if (handle) {
      handle.addEventListener('click', function (e) {
        var rect = frame.getBoundingClientRect();
        var clickX = e.clientX - rect.left;
        var current = rect.width / 2;
        var target = clickX < rect.width / 2 ? 20 : 80;
        setPosition(target);
      });
    }
  });

  // Menu mobile
  var toggle = document.querySelector('[data-mobile-nav-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
      document.body.classList.toggle('nav-open');
    });
  }

  // Swatches produit (taille/couleur)
  document.querySelectorAll('.swatch-list').forEach(function (list) {
    list.addEventListener('click', function (e) {
      var btn = e.target.closest('.swatch');
      if (!btn) return;
      list.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      var input = list.parentElement.querySelector('input[type="hidden"]');
      if (input) input.value = btn.dataset.value;
    });
  });

  // Formulaire newsletter (feedback simple)
  document.querySelectorAll('.newsletter-form').forEach(function (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('button');
      if (btn) btn.textContent = '...';
    });
  });

  // Ajout panier AJAX simple
  document.querySelectorAll('[data-add-to-cart-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function (err) { console.error(err); });
    });
  });
});
